import { createContext } from 'react'

interface BusinessCreateContextType {
  /** @param skip - The number of steps to skip. Default is 0. */
  handleNext: (skip?: number) => void
  handleBack: () => void
}

export const BusinessCreateContext = createContext<BusinessCreateContextType>({
  handleNext: () => {},
  handleBack: () => {},
})
